import {mock} from './index';

export default {
  getUserAppList: () => mock('/user/app/list/v2'),
  getUserAppResource: () => mock('/user/app/resource/list'),
  getUserAppAssetTree: () => mock('/user/app/asset/tree')
};
